<template>
  <div id="enlargeChart" ref="enlargeChart" class="chart-container"
       :style="{width: '100%',height: height || '300px'}">
  </div>
</template>

<script>
import _ from "lodash"

export default {
  name: "enlarge-chart",
  props: {
    type:{
      type: String,            // 0 bar  1 line  2
      default: "bar"
    },
    height: {
      type: String,
    },
    width:{
      type: String,
      default: "100%"
    },
    //echarts参数过多，直接传 option进来解构
    option:{

    },
  },
  data(){
    return {
      enlargeChart: null,
      modalVisible: false
    }
  },
  watch: {
    option: {
      handler(val, oldVal) {
        if(oldVal !== val){
          this.setOption();
        }
      }
    },
    data:{
      handler(val, oldVal) {
        this.$nextTick(_=>{
          this.init();
        })
      }
    }

  },
  mounted() {
    this.$nextTick(() => {
      //  执行echarts方法
      this.init()
    })
  },
  methods: {
    init(){
      const chartRef = this.$refs.enlargeChart;
      if(chartRef){
        this.enlargeChart = this.$echarts.init(chartRef);
        this.enlargeChart && this.setOption();
      }
    },
    setOption(){
      this.enlargeChart.setOption(this.option, true);
    },
  }
}
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 100%;
}
</style>